<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="this.$vuetify.lang.t('$vuetify.DASHBOARD.TITLE')"
      :breadcrumbs="[
        {
          text: this.$vuetify.lang.t('$vuetify.DASHBOARD.DESCRIPTION'),
          disabled: true
        }
      ]"
    />
    <v-card>
      <v-row class="d-flex align-center ma-0">
        <v-col cols="6">
          <v-text-field
            v-model="vehicleSearchString"
            hide-details
            :label="$vuetify.lang.t('$vuetify.SEARCH_BY_VEHICLE')"
            :aria-label="$vuetify.lang.t('$vuetify.SEARCH_BY_VEHICLE')"
            outlined
          >
            <v-icon slot="append">mdi-magnify</v-icon>
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn color="success" type="submit" @click="onVehicleNumnerSearch()">
            {{ $vuetify.lang.t('$vuetify.SEARCH') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="12">
        <fleets-sessions v-if="user" />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Home',
  components: {
    FleetsSessions: () =>
      import(
        /* webpackChunkName: "FleetsSessions" */ '@/components/fleets/FleetsSessions'
      )
  },
  computed: {
    ...mapGetters('authentication', ['user']),
    ...mapGetters('app', ['vehicleNumberSearchString']),
    vehicleSearchString: {
      get() {
        return this.vehicleNumberSearchString
      },
      set(value) {
        this.$store.commit('app/setVehicleNumberSearchString', value)
      }
    }
  },
  watch: {
    vehicleNumberSearchString(newValue) {
      if (!newValue) {
        this.onVehicleNumnerSearch()
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyPress)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyPress)
  },
  methods: {
    ...mapActions('fleets', ['getFleets']),
    onVehicleNumnerSearch() {
      this.getFleets()
    },
    onKeyPress(event) {
      if (this.vehicleNumberSearchString && event.keyCode === 13) {
        this.onVehicleNumnerSearch()
      }
    }
  }
}
</script>
